import React from 'react'
import { useZocksQuota } from '../../../../../components/ScopedBlock/hooks'

const ONEDRIVE_HOW_IT_WORKS_BASE = [
  'Link a OneDrive folder to any client in Zocks',
  'Save generated PDFs - meeting summaries, meeting prep, forms - straight to OneDrive',
  'Keep client documents organized across both platforms',
  'Browse and upload files from OneDrive directly in Zocks',
]

const ONEDRIVE_HOW_IT_WORKS_ULTIMATE = [
  'Pull documents from OneDrive into Zocks for processing - no manual uploads needed',
  'Save document summaries to OneDrive',
  'Work from your existing OneDrive files without leaving the platform',
]

export const OneDriveHowItWorks: React.FC = () => {
  const { hasQuota } = useZocksQuota()
  const documentIntelligenceEnabled = hasQuota('ai.documentSummaryAgent.value')
  const lines = documentIntelligenceEnabled ? [...ONEDRIVE_HOW_IT_WORKS_BASE, ...ONEDRIVE_HOW_IT_WORKS_ULTIMATE] : ONEDRIVE_HOW_IT_WORKS_BASE

  return (
    <div>
      <ul>
        {lines.map((line, i) => (
          <li key={i}>{line}</li>
        ))}
      </ul>
    </div>
  )
}
